import {ToastType, ANIMATION_DELAY} from "./Toast.js";

interface ToastParams {
	content: string;
	id?:     string;
	type?:   ToastType;
};

/**
 * Shows a toast message. Can be used in two ways:
 * 1. toast("Toast message")
 * 2. toast({...options})
 */
export const toast = (arg: string | ToastParams) => {
	const helperParams = (typeof arg === "string")
		? {content: arg}
		: arg;

	toastHelper(helperParams);
};

const toastHelper = (props: ToastParams) => {
	const {
		content = "",
		id = null,
		type = "success"
	} = props;

	// Set toast properties
	const toastElem = document.createElement("pn-toast");
	toastElem.content = content;
	toastElem.type = type;

	// If a toast with the same ID already exists, clear it first
	const clearingOldToast = false;
	if (id) {
		toastElem.id = id;

		const sameIdToast = document.querySelector(`pn-toast#${id}`);
		sameIdToast?.remove();
	}

	// Add toast to DOM
	if (clearingOldToast)
		setTimeout(() => document.body.append(toastElem), ANIMATION_DELAY);
	else
		document.body.append(toastElem);
};

